<template>
  <div id="modalMeasureDetails" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detalhes de Medição</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div v-if="!isLoading" class="modal-body">
          <StepsMeasure :status="measure.status" :logs="measure.logs" />
          <hr />
          <CertificationMeasure
            v-if="measure.type === 'Contrato'"
            :measure="measure"
          />
          <hr />
          <ItemsMeasure
            :items="measure.itens"
            :totalValue="measure.totalValue"
          />
          <hr />
          <AttachsMeasure :measure="measure" />
        </div>
        <div class="modal-footer border-top-0 pt-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StepsMeasure from '@/components/documents/commons/measure/StepsMeasure.vue'
import CertificationMeasure from '@/components/documents/commons/measure/CertificationMeasure.vue'
import ItemsMeasure from '@/components/documents/commons/measure/ItemsMeasure.vue'
import AttachsMeasure from '@/components/documents/commons/measure/AttachsMeasure.vue'
import { showModal, hideModal } from '@/utils/modal'

export default {
  name: 'MeasureDetailsModal',

  props: {
    measureId: {
      type: String,
      required: true,
    },
  },

  components: {
    StepsMeasure,
    CertificationMeasure,
    ItemsMeasure,
    AttachsMeasure,
  },

  data() {
    return {
      isLoading: true,
    }
  },

  methods: {
    async getMeasure() {
      try {
        this.measure = await this.$store.dispatch('getMeasure', this.measureId)
        this.isLoading = false
        showModal('modalMeasureDetails')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },
  },

  mounted() {
    this.getMeasure()
  },

  beforeUnmount() {
    hideModal()
    this.$emit('closeModal', false)
  },
}
</script>
